(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["holiday-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (preference.matches || !('IntersectionObserver' in window) || document.documentElement.classList.contains('shopify-design-mode')) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.setAttribute('data-mvurra-visible', '');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.05, rootMargin: '0px 0px 40px 0px' });
    const prepare = () => {
      if (preference.matches) return;
      document.querySelectorAll('.ee-home [data-mvurra-reveal]:not([data-mvurra-ready])').forEach((item) => {
        if (item.getBoundingClientRect().top <= window.innerHeight) item.setAttribute('data-mvurra-visible', '');
        item.setAttribute('data-mvurra-ready', '');
        if (!item.hasAttribute('data-mvurra-visible')) observer.observe(item);
      });
    };
    prepare();
    document.addEventListener('shopify:section:load', prepare);
    document.addEventListener('focusin', (event) => {
      const item = event.target.closest?.('[data-mvurra-ready]');
      if (!item) return;
      item.setAttribute('data-mvurra-visible', '');
      observer.unobserve(item);
    });
    preference.addEventListener('change', (event) => {
      if (!event.matches) return;
      observer.disconnect();
      document.querySelectorAll('[data-mvurra-ready]').forEach((item) => item.setAttribute('data-mvurra-visible', ''));
    });
  })();

  (() => {
    const initialize = (root) => {
      if (root.dataset.mvInitialized) return;
      const viewport = root.querySelector('[data-mv-viewport]');
      const slides = Array.from(root.querySelectorAll('[data-mv-slide]'));
      const pickers = Array.from(root.querySelectorAll('[data-mv-picker]'));
      const controls = root.querySelector('[data-mv-controls]');
      const status = root.querySelector('[data-mv-status]');
      if (!viewport || slides.length < 2 || pickers.length !== slides.length || !controls) return;
      root.dataset.mvInitialized = 'true';
      viewport.tabIndex = 0;
      viewport.setAttribute('aria-label', 'Featured collections. Use left and right arrow keys to browse.');
      let current = 0;
      let gesture = null;
      let suppressClickUntil = 0;
      const show = (requested) => {
        const next = (requested + slides.length) % slides.length;
        if (next === current) return;
        const previous = slides[current];
        if (previous.contains(document.activeElement)) viewport.focus({ preventScroll: true });
        current = next;
        slides.forEach((slide, index) => {
          const active = index === current;
          slide.hidden = !active;
          slide.setAttribute('aria-hidden', String(!active));
          slide.classList.toggle('mv-art-slide--entered', active);
          if (active) {
            const image = slide.querySelector('img');
            if (image) image.loading = 'eager';
          }
        });
        pickers.forEach((picker, index) => picker.setAttribute('aria-disabled', String(index === current)));
        if (status) status.textContent = slides[current].dataset.slideName + ' — ' + (current + 1) + ' of ' + slides.length;
      };
      root.querySelector('[data-mv-previous]').addEventListener('click', () => show(current - 1));
      root.querySelector('[data-mv-next]').addEventListener('click', () => show(current + 1));
      pickers.forEach((picker, index) => picker.addEventListener('click', () => show(index)));
      root.addEventListener('keydown', (event) => {
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        if (event.target !== viewport && !event.target.closest('[data-mv-controls]')) return;
        let next;
        if (event.key === 'ArrowRight') next = current + 1;
        else if (event.key === 'ArrowLeft') next = current - 1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = slides.length - 1;
        else return;
        event.preventDefault();
        const pickerFocused = event.target.matches('[data-mv-picker]');
        show(next);
        if (pickerFocused) pickers[current].focus();
      });
      viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
        if (event.isPrimary === false) { gesture = null; return; }
        if (event.target.closest('button')) return;
        gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, horizontal: false };
      }, { passive: true });
      viewport.addEventListener('pointermove', (event) => {
        if (!gesture || event.pointerId !== gesture.id) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        if (!gesture.horizontal) {
          if (Math.abs(dy) > 14 && Math.abs(dy) > Math.abs(dx)) { gesture = null; return; }
          if (Math.abs(dx) < 14 || Math.abs(dx) < Math.abs(dy) * 1.35) return;
          gesture.horizontal = true;
          viewport.setPointerCapture?.(event.pointerId);
        }
        if (event.cancelable) event.preventDefault();
      }, { passive: false });
      viewport.addEventListener('pointerup', (event) => {
        if (!gesture || event.pointerId !== gesture.id) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        const isSwipe = gesture.horizontal && Math.abs(dx) >= 48 && Math.abs(dx) > Math.abs(dy) * 1.35;
        gesture = null;
        if (!isSwipe) return;
        suppressClickUntil = performance.now() + 450;
        show(current + (dx < 0 ? 1 : -1));
      });
      viewport.addEventListener('pointercancel', () => { gesture = null; });
      viewport.addEventListener('click', (event) => {
        if (performance.now() >= suppressClickUntil) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);
      controls.hidden = false;
    };
    const prepare = () => document.querySelectorAll('[data-mv-carousel]').forEach(initialize);
    prepare();
    document.addEventListener('shopify:section:load', prepare);
  })();


  (() => {
    const storageKey = 'mvurra:saved-products:v1';
    let cartBusy = false;
    let eventModule;
    let visitSaved = new Set();
    const decodeSaved = (value) => {
      try { const list = JSON.parse(value || '[]'); return new Set(Array.isArray(list) ? list.slice(0, 500).map(String).filter((id) => /^\d+$/.test(id)) : []); }
      catch { return new Set(); }
    };
    const initialize = (root) => {
      if (root.dataset.mvCardsInitialized) return;
      root.dataset.mvCardsInitialized = 'true';
      root._mvCardController = new AbortController();
      const signal = root._mvCardController.signal;
      const on = (target, type, handler, options = {}) => target?.addEventListener(type, handler, { ...options, signal });
      const strings = root.querySelector('[data-mv-card-strings]')?.dataset || {};
      const t = (key, values = {}) => {
        let value = strings[key] || '';
        for (const [name, replacement] of Object.entries(values)) value = value.replaceAll('__MV_' + name.toUpperCase() + '__', String(replacement));
        return value;
      };
      const cards = Array.from(root.querySelectorAll('[data-mv-card]'));
      const toolbar = root.querySelector('[data-mv-saved-toolbar]');
      const savedButton = root.querySelector('[data-mv-show-saved]');
      const status = root.querySelector('[data-mv-saved-status]');
      let saved = new Set();
      let durableStorage = true;
      let savedOnly = false;
      let activeClosePanel;
      try { saved = decodeSaved(window.localStorage.getItem(storageKey)); }
      catch { durableStorage = false; saved = new Set(visitSaved); }
      const announce = (message) => { if (status) status.textContent = message; };
      const updateSaved = () => {
        let count = 0;
        cards.forEach((card) => {
          const isSaved = saved.has(card.dataset.productId);
          if (isSaved) count += 1;
          const button = card.querySelector('[data-mv-save]');
          if (button) {
            button.setAttribute('aria-pressed', String(isSaved));
            button.setAttribute('aria-label', t(isSaved ? 'removeSaved' : durableStorage ? 'saveDevice' : 'saveVisit', { title: card.dataset.productTitle }));
          }
          const shouldHide = savedOnly && !isSaved;
          if (shouldHide && card.querySelector('[data-mv-quickshop]')?.open) activeClosePanel?.(false);
          if (shouldHide && card.contains(document.activeElement)) savedButton?.focus({ preventScroll: true });
          card.hidden = shouldHide;
        });
        root.querySelector('[data-mv-saved-count]').textContent = String(count);
        root.querySelector('[data-mv-saved-label]').textContent = t(durableStorage ? 'savedDevice' : 'savedVisit');
        root.querySelector('[data-mv-storage-note]').textContent = t(durableStorage ? 'storageNote' : 'storageFailure');
        savedButton?.setAttribute('aria-pressed', String(savedOnly));
        root.querySelectorAll('[data-mv-show-all]').forEach((button) => button.setAttribute('aria-pressed', String(!savedOnly)));
        root.querySelector('[data-mv-saved-empty]').hidden = !savedOnly || count > 0;
      };
      root.querySelectorAll('[data-mv-show-all]').forEach((button) => on(button, 'click', () => { savedOnly = false; updateSaved(); announce(t('showingAll')); }));
      on(savedButton, 'click', () => { savedOnly = true; updateSaved(); announce(t('showingSaved', { count: cards.filter((card) => saved.has(card.dataset.productId)).length })); });
      cards.forEach((card) => {
        const favorite = card.querySelector('[data-mv-save]');
        on(favorite, 'click', () => {
          const id = card.dataset.productId;
          if (!id) return;
          const removing = saved.has(id);
          if (removing) saved.delete(id); else saved.add(id);
          if (durableStorage) { try { window.localStorage.setItem(storageKey, JSON.stringify(Array.from(saved))); } catch { durableStorage = false; } }
          visitSaved = new Set(saved);
          updateSaved();
          announce(t(removing ? 'removedStatus' : durableStorage ? 'savedDeviceStatus' : 'savedVisitStatus', { title: card.dataset.productTitle }));
        });
        const images = Array.from(card.querySelectorAll('[data-mv-card-image]'));
        const gallery = card.querySelector('[data-mv-gallery-controls]');
        const previous = card.querySelector('[data-mv-image-previous]');
        const next = card.querySelector('[data-mv-image-next]');
        let imageIndex = 0;
        const showImage = (requested, userAction = false) => {
          const focusedControl = userAction ? document.activeElement : null;
          const selected = Math.max(0, Math.min(images.length - 1, requested));
          imageIndex = selected;
          images.forEach((item, index) => { item.hidden = index !== selected; if (index === selected) { const image = item.querySelector('img'); if (image && userAction) image.loading = 'eager'; } });
          if (!gallery || !previous || !next) return;
          previous.hidden = selected === 0;
          next.hidden = selected === images.length - 1;
          card.querySelector('[data-mv-image-count]').textContent = (selected + 1) + ' / ' + images.length;
          if (userAction) {
            card.querySelector('[data-mv-image-status]').textContent = t('imageStatus', { title: card.dataset.productTitle, current: selected + 1, total: images.length });
            if (focusedControl === previous && previous.hidden && !next.hidden) next.focus({ preventScroll: true });
            else if (focusedControl === next && next.hidden && !previous.hidden) previous.focus({ preventScroll: true });
          }
        };
        if (gallery && images.length > 1) {
          showImage(0);
          gallery.hidden = false;
          on(previous, 'click', () => showImage(imageIndex - 1, true));
          on(next, 'click', () => showImage(imageIndex + 1, true));
          on(gallery, 'keydown', (event) => {
            if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
            let requested;
            if (event.key === 'ArrowLeft') requested = imageIndex - 1;
            else if (event.key === 'ArrowRight') requested = imageIndex + 1;
            else if (event.key === 'Home') requested = 0;
            else if (event.key === 'End') requested = images.length - 1;
            else return;
            event.preventDefault(); showImage(requested, true);
          });
        }
        const panel = card.querySelector('[data-mv-quickshop]');
        const opener = card.querySelector('[data-mv-options-open]');
        const details = card.querySelector('[data-mv-card-details]');
        let variants = [];
        let refreshOptions = () => {};
        const closePanel = (restoreFocus = true) => {
          if (!panel) return;
          if (panel.open) panel.close();
          if (activeClosePanel === closePanel) activeClosePanel = null;
          panel.hidden = true;
          if (details) details.hidden = false;
          opener?.setAttribute('aria-expanded', 'false');
          if (restoreFocus && opener) opener.focus({ preventScroll: true });
        };
        if (panel) signal.addEventListener('abort', () => closePanel(false), { once: true });
        if (panel && opener) {
          variants = Array.from(panel.querySelectorAll('[data-mv-variant]')).flatMap((item) => {
            try { const options = JSON.parse(item.dataset.variantOptions); return Array.isArray(options) ? [{ id: item.dataset.variantId, options: options.map(String), available: item.dataset.variantAvailable === 'true', price: item.dataset.variantPrice, minimum: Number(item.dataset.variantMin) || 1, increment: Number(item.dataset.variantIncrement) || 1, maximum: item.dataset.variantMax ? Number(item.dataset.variantMax) : null }] : []; }
            catch { return []; }
          });
          const groups = Array.from(panel.querySelectorAll('[data-mv-option-group]'));
          const form = panel.querySelector('[data-mv-quick-form]');
          const submit = panel.querySelector('[data-mv-add]');
          refreshOptions = () => {
            const selected = groups.map((group) => group.querySelector('input:checked')?.value ?? null);
            groups.forEach((group, index) => {
              group.querySelectorAll('[data-mv-option]').forEach((input) => {
                const available = variants.some((variant) => variant.available && variant.options[index] === input.value && selected.every((value, other) => other >= index || value === null || variant.options[other] === value));
                input.disabled = !available;
                if (!available && input.checked) { input.checked = false; selected[index] = null; }
                input.closest('label')?.setAttribute('title', available ? '' : t('unavailableSelection'));
              });
            });
            const complete = selected.every((value) => value !== null);
            const variant = complete ? variants.find((item) => item.available && item.options.every((value, index) => selected[index] === value)) : null;
            form.elements.namedItem('id').value = variant?.id || '';
            const quantitySupported = !variant || (variant.minimum === 1 && variant.increment === 1 && variant.maximum === null);
            submit.disabled = !variant || !quantitySupported || form.dataset.busy === 'true';
            const missing = groups.find((group) => !group.querySelector('input:checked'));
            submit.textContent = form.dataset.busy === 'true' ? t('adding') : variant ? t('addToBag') : missing ? t('selectOption', { option: missing.dataset.optionName }) : t('unavailable');
            panel.querySelector('[data-mv-option-price]').textContent = !quantitySupported ? t('quantityDetails') : variant ? variant.price : t('selectPrice');
          };
          on(panel, 'change', (event) => { if (event.target.matches('[data-mv-option]')) refreshOptions(); });
          const mobileSheet = window.matchMedia('(max-width: 767px)');
          const openPanel = () => {
            if (activeClosePanel && activeClosePanel !== closePanel) activeClosePanel(false);
            if (!variants.length || typeof panel.showModal !== 'function' || typeof panel.show !== 'function') { window.location.assign(card.querySelector('.mv-card-image-link').href); return; }
            if (panel.open) panel.close();
            panel.hidden = false;
            if (details) details.hidden = !mobileSheet.matches;
            panel.setAttribute('aria-modal', String(mobileSheet.matches));
            if (mobileSheet.matches) panel.showModal(); else panel.show();
            activeClosePanel = closePanel;
            const inlineFeedback = panel.querySelector('[data-mv-inline-feedback]');
            if (inlineFeedback) { inlineFeedback.textContent = ''; inlineFeedback.hidden = true; }
            opener.setAttribute('aria-expanded', 'true'); refreshOptions();
          };
          on(opener, 'click', () => {
            openPanel();
            if (panel.open) (panel.querySelector('[data-mv-option]:not(:disabled)') || panel.querySelector('[data-mv-options-close]')).focus({ preventScroll: true });
          });
          on(mobileSheet, 'change', () => {
            if (!panel.open) return;
            const focused = panel.contains(document.activeElement) ? document.activeElement : null;
            openPanel();
            focused?.focus({ preventScroll: true });
          });
          on(panel, 'cancel', (event) => { event.preventDefault(); closePanel(); });
          on(panel, 'click', (event) => {
            if (!mobileSheet.matches || event.target !== panel) return;
            const bounds = panel.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closePanel();
          });
          on(panel.querySelector('[data-mv-options-close]'), 'click', () => closePanel());
          on(panel, 'keydown', (event) => { if (event.key === 'Escape') { event.preventDefault(); closePanel(); } });
          refreshOptions();
        }
        const feedback = (message) => {
          if (panel?.open) { const inline = panel.querySelector('[data-mv-inline-feedback]'); if (inline) { inline.hidden = false; inline.textContent = message; return; } }
          const area = card.querySelector('[data-mv-feedback]'); if (area) { area.hidden = false; area.querySelector('[data-mv-feedback-message]').textContent = message; } };
        card.querySelectorAll('[data-mv-quick-form]').forEach((form) => on(form, 'submit', async (event) => {
          event.preventDefault();
          if (cartBusy || form.dataset.busy === 'true') { feedback(t('waitForBag')); return; }
          const variantId = String(form.elements.namedItem('id')?.value || '');
          if (!/^\d+$/.test(variantId)) { feedback(t('chooseBeforeAdd')); return; }
          if (panel && form.closest('[data-mv-quickshop]') && !variants.some((variant) => variant.id === variantId && variant.available && variant.minimum === 1 && variant.increment === 1 && variant.maximum === null)) { feedback(t('optionUnavailable')); return; }
          cartBusy = true; form.dataset.busy = 'true'; form.setAttribute('aria-busy', 'true');
          const submit = form.querySelector('[data-mv-add]'); if (submit) submit.disabled = true;
          const choices = Array.from(form.querySelectorAll('[data-mv-option]')); choices.forEach((input) => { input.dataset.wasDisabled = String(input.disabled); input.disabled = true; });
          if (panel && form.closest('[data-mv-quickshop]')) submit.textContent = t('adding');
          let confirmed = false;
          try {
            const sectionIds = Array.from(new Set(Array.from(document.querySelectorAll('cart-items-component')).map((item) => item.dataset.sectionId).filter(Boolean))).slice(0, 5);
            const payload = { items: [{ id: Number(variantId), quantity: 1 }] };
            if (sectionIds.length) { payload.sections = sectionIds; payload.sections_url = window.location.pathname; }
            const endpoint = form.getAttribute('action').replace(/\.js$/, '') + '.js';
            const response = await fetch(endpoint, { method: 'POST', credentials: 'same-origin', signal, headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
            const added = await response.json();
            if (!response.ok || added.status) { const message = typeof added.description === 'string' ? added.description : t('addError'); feedback(message); return; }
            confirmed = true;
            const cartResponse = await fetch(root.dataset.cartUrl.replace(/\.js$/, '') + '.js', { credentials: 'same-origin', signal, cache: 'no-store', headers: { Accept: 'application/json' } });
            if (!cartResponse.ok) throw new Error('Cart refresh failed');
            const cart = await cartResponse.json();
            if (!Number.isInteger(cart.item_count)) throw new Error('Cart count unavailable');
            eventModule ||= import('@shopify/events');
            const { CartLinesUpdateEvent } = await eventModule;
            if (panel && !panel.hidden) closePanel();
            feedback(t('added'));
            card.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: variantId, quantity: 1 }], promise: Promise.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'mvurra-home-cards', sourceId: card.id, itemCount: 1, productId: card.dataset.productId, sections: added.sections, didError: false } }) }));
          } catch {
            if (signal.aborted || !root.isConnected) return;
            if (confirmed) { feedback(t('addedOpening')); window.location.assign(root.dataset.cartUrl); }
            else feedback(t('unconfirmed'));
          } finally {
            cartBusy = false; form.dataset.busy = 'false'; form.removeAttribute('aria-busy');
            choices.forEach((input) => { input.disabled = input.dataset.wasDisabled === 'true'; delete input.dataset.wasDisabled; });
            if (panel && form.closest('[data-mv-quickshop]')) refreshOptions(); else if (submit) submit.disabled = false;
          }
        }));
        const controls = card.querySelector('[data-mv-card-controls]'); if (controls) controls.hidden = false;
      });
      updateSaved(); if (toolbar) toolbar.hidden = false;
      on(window, 'storage', (event) => { if (durableStorage && (event.key === storageKey || event.key === null)) { saved = decodeSaved(event.newValue); updateSaved(); } });
    };
    import('@theme/component').then(({ Component }) => {
      if (customElements.get('mvurra-product-cards')) return;
      class MvurraProductCards extends Component {
        connectedCallback() { super.connectedCallback(); initialize(this); }
        updatedCallback() { super.updatedCallback(); this._mvCardController?.abort(); delete this.dataset.mvCardsInitialized; initialize(this); }
        disconnectedCallback() { super.disconnectedCallback(); this._mvCardController?.abort(); delete this.dataset.mvCardsInitialized; }
      }
      customElements.define('mvurra-product-cards', MvurraProductCards);
    }).catch(() => { /* Native product links remain available when enhancement cannot load. */ });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  if (!customElements.get('mv-collection-shell')) {
    customElements.define('mv-collection-shell', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.setAttribute('data-enhanced', '');
        this.querySelector('[data-testid="product-grid"]')?.setAttribute('product-grid-view', 'default');
        this.addEventListener('click', (event) => {
          const button = event.target instanceof Element ? event.target.closest('[data-mv-filter-toggle]') : null;
          if (!button || !this.contains(button)) return;
          const expanded = this.toggleAttribute('data-filters-open');
          button.setAttribute('aria-expanded', String(expanded));
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mvurra-editorial-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mvurra-editorial-footer')) {
    customElements.define('mvurra-editorial-footer', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const topButton = this.querySelector('[data-mv-footer-top]');
        if (!topButton) return;
        topButton.hidden = false;
        topButton.addEventListener('click', () => {
          const firstLink = document.querySelector('header a[href], header-component a[href]');
          if (firstLink) firstLink.focus({ preventScroll: true });
          window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mvurra-featured-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'mvurra:saved-products:v1';
    let cartBusy = false;
    let eventModule;
    let visitSaved = new Set();
    const decodeSaved = (value) => {
      try { const list = JSON.parse(value || '[]'); return new Set(Array.isArray(list) ? list.slice(0, 500).map(String).filter((id) => /^\d+$/.test(id)) : []); }
      catch { return new Set(); }
    };
    const initialize = (root) => {
      if (root.dataset.mvCardsInitialized) return;
      root.dataset.mvCardsInitialized = 'true';
      root._mvCardController = new AbortController();
      const signal = root._mvCardController.signal;
      const on = (target, type, handler, options = {}) => target?.addEventListener(type, handler, { ...options, signal });
      const strings = root.querySelector('[data-mv-card-strings]')?.dataset || {};
      const t = (key, values = {}) => {
        let value = strings[key] || '';
        for (const [name, replacement] of Object.entries(values)) value = value.replaceAll('__MV_' + name.toUpperCase() + '__', String(replacement));
        return value;
      };
      const cards = Array.from(root.querySelectorAll('[data-mv-card]'));
      const toolbar = root.querySelector('[data-mv-saved-toolbar]');
      const savedButton = root.querySelector('[data-mv-show-saved]');
      const status = root.querySelector('[data-mv-saved-status]');
      let saved = new Set();
      let durableStorage = true;
      let savedOnly = false;
      let activeClosePanel;
      let activePanel;
      const pageWrapper = root.closest('.page-wrapper');
      const pageScroller = () => pageWrapper && /auto|scroll/.test(getComputedStyle(pageWrapper).overflowY) ? pageWrapper : window;
      const capturePageScroll = () => {
        const target = pageScroller();
        return { target, left: target === window ? window.scrollX : target.scrollLeft, top: target === window ? window.scrollY : target.scrollTop };
      };
      const restorePageScroll = ({ target, left, top }) => {
        const currentLeft = target === window ? window.scrollX : target.scrollLeft;
        const currentTop = target === window ? window.scrollY : target.scrollTop;
        if (currentLeft !== left || currentTop !== top) target.scrollTo({ left, top, behavior: 'instant' });
      };
      on(document, 'mvurra:quickshop-open', (event) => {
        if (activePanel && event.detail?.owner !== activePanel) activeClosePanel?.(false);
      });
      try { saved = decodeSaved(window.localStorage.getItem(storageKey)); }
      catch { durableStorage = false; saved = new Set(visitSaved); }
      const announce = (message) => { if (status) status.textContent = message; };
      const updateSaved = () => {
        let count = 0;
        cards.forEach((card) => {
          const isSaved = saved.has(card.dataset.productId);
          if (isSaved) count += 1;
          const button = card.querySelector('[data-mv-save]');
          if (button) {
            button.setAttribute('aria-pressed', String(isSaved));
            button.setAttribute('aria-label', t(isSaved ? 'removeSaved' : durableStorage ? 'saveDevice' : 'saveVisit', { title: card.dataset.productTitle }));
          }
          const shouldHide = savedOnly && !isSaved;
          if (shouldHide && card.querySelector('[data-mv-quickshop]')?.open) activeClosePanel?.(false);
          if (shouldHide && card.contains(document.activeElement)) savedButton?.focus({ preventScroll: true });
          card.hidden = shouldHide;
        });
        root.querySelector('[data-mv-saved-count]').textContent = String(count);
        root.querySelector('[data-mv-saved-label]').textContent = t(durableStorage ? 'savedDevice' : 'savedVisit');
        root.querySelector('[data-mv-storage-note]').textContent = t(durableStorage ? 'storageNote' : 'storageFailure');
        savedButton?.setAttribute('aria-pressed', String(savedOnly));
        root.querySelectorAll('[data-mv-show-all]').forEach((button) => button.setAttribute('aria-pressed', String(!savedOnly)));
        root.querySelector('[data-mv-saved-empty]').hidden = !savedOnly || count > 0;
      };
      root.querySelectorAll('[data-mv-show-all]').forEach((button) => on(button, 'click', () => { savedOnly = false; updateSaved(); announce(t('showingAll')); }));
      on(savedButton, 'click', () => { savedOnly = true; updateSaved(); announce(t('showingSaved', { count: cards.filter((card) => saved.has(card.dataset.productId)).length })); });
      cards.forEach((card) => {
        const favorite = card.querySelector('[data-mv-save]');
        on(favorite, 'click', () => {
          const id = card.dataset.productId;
          if (!id) return;
          const removing = saved.has(id);
          if (removing) saved.delete(id); else saved.add(id);
          if (durableStorage) { try { window.localStorage.setItem(storageKey, JSON.stringify(Array.from(saved))); } catch { durableStorage = false; } }
          visitSaved = new Set(saved);
          updateSaved();
          announce(t(removing ? 'removedStatus' : durableStorage ? 'savedDeviceStatus' : 'savedVisitStatus', { title: card.dataset.productTitle }));
        });
        const images = Array.from(card.querySelectorAll('[data-mv-card-image]'));
        const gallery = card.querySelector('[data-mv-gallery-controls]');
        const previous = card.querySelector('[data-mv-image-previous]');
        const next = card.querySelector('[data-mv-image-next]');
        let imageIndex = 0;
        const showImage = (requested, userAction = false) => {
          const focusedControl = userAction ? document.activeElement : null;
          const selected = Math.max(0, Math.min(images.length - 1, requested));
          imageIndex = selected;
          images.forEach((item, index) => { item.hidden = index !== selected; if (index === selected) { const image = item.querySelector('img'); if (image && userAction) image.loading = 'eager'; } });
          if (!gallery || !previous || !next) return;
          previous.hidden = selected === 0;
          next.hidden = selected === images.length - 1;
          card.querySelector('[data-mv-image-count]').textContent = (selected + 1) + ' / ' + images.length;
          if (userAction) {
            card.querySelector('[data-mv-image-status]').textContent = t('imageStatus', { title: card.dataset.productTitle, current: selected + 1, total: images.length });
            if (focusedControl === previous && previous.hidden && !next.hidden) next.focus({ preventScroll: true });
            else if (focusedControl === next && next.hidden && !previous.hidden) previous.focus({ preventScroll: true });
          }
        };
        if (gallery && images.length > 1) {
          showImage(0);
          gallery.hidden = false;
          on(previous, 'click', () => showImage(imageIndex - 1, true));
          on(next, 'click', () => showImage(imageIndex + 1, true));
          on(gallery, 'keydown', (event) => {
            if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
            let requested;
            if (event.key === 'ArrowLeft') requested = imageIndex - 1;
            else if (event.key === 'ArrowRight') requested = imageIndex + 1;
            else if (event.key === 'Home') requested = 0;
            else if (event.key === 'End') requested = images.length - 1;
            else return;
            event.preventDefault(); showImage(requested, true);
          });
        }
        const panel = card.querySelector('[data-mv-quickshop]');
        const opener = card.querySelector('[data-mv-options-open]');
        const media = card.querySelector('.mv-card-media');
        const details = card.querySelector('[data-mv-card-details]');
        let variants = [];
        let refreshOptions = () => {};
        const closePanel = (restoreFocus = true) => {
          if (!panel) return;
          const scroll = capturePageScroll();
          const wasOpen = panel.open;
          if (media) media.hidden = false;
          if (details) details.hidden = false;
          if (panel.open) panel.close();
          if (activeClosePanel === closePanel) { activeClosePanel = null; activePanel = null; }
          panel.hidden = true;
          delete card.dataset.mvQuickshopLayout;
          card.style.removeProperty('--mv-card-closed-height');
          opener?.setAttribute('aria-expanded', 'false');
          if (restoreFocus && opener) opener.focus({ preventScroll: true });
          if (wasOpen && root.isConnected) restorePageScroll(scroll);
        };
        if (panel) signal.addEventListener('abort', () => closePanel(false), { once: true });
        if (panel && opener) {
          variants = Array.from(panel.querySelectorAll('[data-mv-variant]')).flatMap((item) => {
            try { const options = JSON.parse(item.dataset.variantOptions); return Array.isArray(options) ? [{ id: item.dataset.variantId, options: options.map(String), available: item.dataset.variantAvailable === 'true', price: item.dataset.variantPrice, minimum: Number(item.dataset.variantMin) || 1, increment: Number(item.dataset.variantIncrement) || 1, maximum: item.dataset.variantMax ? Number(item.dataset.variantMax) : null }] : []; }
            catch { return []; }
          });
          const groups = Array.from(panel.querySelectorAll('[data-mv-option-group]'));
          const form = panel.querySelector('[data-mv-quick-form]');
          const submit = panel.querySelector('[data-mv-add]');
          refreshOptions = () => {
            const selected = groups.map((group) => group.querySelector('input:checked')?.value ?? null);
            groups.forEach((group, index) => {
              group.querySelectorAll('[data-mv-option]').forEach((input) => {
                const available = variants.some((variant) => variant.available && variant.options[index] === input.value && selected.every((value, other) => other >= index || value === null || variant.options[other] === value));
                input.disabled = !available;
                if (!available && input.checked) { input.checked = false; selected[index] = null; }
                input.closest('label')?.setAttribute('title', available ? '' : t('unavailableSelection'));
              });
            });
            const complete = selected.every((value) => value !== null);
            const variant = !groups.length && variants.length === 1 ? variants[0] : complete ? variants.find((item) => item.available && item.options.every((value, index) => selected[index] === value)) : null;
            form.elements.namedItem('id').value = variant?.id || '';
            const quantity = form.elements.namedItem('quantity');
            quantity.min = String(variant?.minimum || 1);
            quantity.step = String(variant?.increment || 1);
            if (variant?.maximum) quantity.max = String(variant.maximum); else quantity.removeAttribute('max');
            if (form.dataset.quantityVariant !== variant?.id) {
              quantity.value = quantity.min;
              form.dataset.quantityVariant = variant?.id || '';
            }
            submit.disabled = !variant?.available || form.dataset.busy === 'true';
            const missing = groups.find((group) => !group.querySelector('input:checked'));
            submit.textContent = form.dataset.busy === 'true' ? t('adding') : variant ? t('addToBag') : missing ? t('selectOption', { option: missing.dataset.optionName }) : t('unavailable');
            panel.querySelector('[data-mv-option-price]').textContent = variant ? variant.price : t('selectPrice');
          };
          on(panel.querySelector('[data-mv-quantity-minus]'), 'click', () => { form.elements.namedItem('quantity').stepDown(); });
          on(panel.querySelector('[data-mv-quantity-plus]'), 'click', () => { form.elements.namedItem('quantity').stepUp(); });
          on(panel, 'change', (event) => { if (event.target.matches('[data-mv-option]')) refreshOptions(); });
          const mobileSheet = window.matchMedia('(max-width: 767px)');
          const openPanel = () => {
            if (!variants.length || typeof panel.showModal !== 'function' || typeof panel.show !== 'function') { window.location.assign(card.querySelector('.mv-card-image-link').href); return; }
            const scroll = capturePageScroll();
            document.dispatchEvent(new CustomEvent('mvurra:quickshop-open', { detail: { owner: panel } }));
            if (panel.open) panel.close();
            panel.hidden = true;
            if (media) media.hidden = false;
            if (details) details.hidden = false;
            delete card.dataset.mvQuickshopLayout;
            card.style.removeProperty('--mv-card-closed-height');
            const feedbackArea = card.querySelector('[data-mv-feedback]');
            if (feedbackArea) feedbackArea.hidden = true;
            if (!mobileSheet.matches) {
              card.style.setProperty('--mv-card-closed-height', card.getBoundingClientRect().height + 'px');
              card.dataset.mvQuickshopLayout = 'inline';
              if (media) media.hidden = true;
              if (details) details.hidden = true;
            }
            panel.hidden = false;
            panel.setAttribute('aria-modal', String(mobileSheet.matches));
            if (mobileSheet.matches) panel.showModal(); else panel.show();
            activeClosePanel = closePanel;
            activePanel = panel;
            const inlineFeedback = panel.querySelector('[data-mv-inline-feedback]');
            if (inlineFeedback) { inlineFeedback.textContent = ''; inlineFeedback.hidden = true; }
            opener.setAttribute('aria-expanded', 'true'); refreshOptions();
            panel.scrollTop = 0;
            restorePageScroll(scroll);
            if (!mobileSheet.matches) requestAnimationFrame(() => {
              if (activePanel !== panel || !panel.open || !panel.isConnected || mobileSheet.matches) return;
              const target = pageScroller();
              const viewport = target === window ? { top: 0, bottom: window.innerHeight } : target.getBoundingClientRect();
              const header = document.querySelector('header-component[sticky]');
              const visibleTop = Math.max(0, viewport.top, header?.getBoundingClientRect().bottom ?? 0) + 12;
              const close = panel.querySelector('[data-mv-options-close]');
              const visibleBottom = Math.min(window.innerHeight, viewport.bottom) - (close?.offsetHeight ?? 44) - 12;
              const panelTop = panel.getBoundingClientRect().top;
              if (panelTop >= visibleTop && panelTop <= visibleBottom) return;
              target.scrollBy({ top: panelTop - visibleTop, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
            });
          };
          on(opener, 'click', () => {
            openPanel();
            if (panel.open) (panel.querySelector('[data-mv-option]:not(:disabled)') || panel.querySelector('input[name=quantity]') || panel.querySelector('[data-mv-options-close]')).focus({ preventScroll: true });
          });
          on(mobileSheet, 'change', () => {
            if (!panel.open) return;
            const focused = panel.contains(document.activeElement) ? document.activeElement : null;
            openPanel();
            focused?.focus({ preventScroll: true });
          });
          on(panel, 'cancel', (event) => { event.preventDefault(); closePanel(); });
          on(panel, 'click', (event) => {
            if (!mobileSheet.matches || event.target !== panel) return;
            const bounds = panel.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closePanel();
          });
          on(panel.querySelector('[data-mv-options-close]'), 'click', () => closePanel());
          on(panel, 'keydown', (event) => { if (event.key === 'Escape') { event.preventDefault(); closePanel(); } });
          refreshOptions();
        }
        const feedback = (message) => {
          if (panel?.open) { const inline = panel.querySelector('[data-mv-inline-feedback]'); if (inline) { inline.hidden = false; inline.textContent = message; return; } }
          const area = card.querySelector('[data-mv-feedback]'); if (area) { area.hidden = false; area.querySelector('[data-mv-feedback-message]').textContent = message; } };
        card.querySelectorAll('[data-mv-quick-form]').forEach((form) => on(form, 'submit', async (event) => {
          event.preventDefault();
          if (cartBusy || form.dataset.busy === 'true') { feedback(t('waitForBag')); return; }
          const variantId = String(form.elements.namedItem('id')?.value || '');
          if (!/^\d+$/.test(variantId)) { feedback(t('chooseBeforeAdd')); return; }
          const quantity = Number(form.elements.namedItem('quantity')?.value);
          const selectedVariant = variants.find((variant) => variant.id === variantId && variant.available);
          if (!selectedVariant || !Number.isInteger(quantity) || quantity < selectedVariant.minimum || (selectedVariant.maximum && quantity > selectedVariant.maximum) || (quantity - selectedVariant.minimum) % selectedVariant.increment !== 0) { form.reportValidity(); feedback(t('optionUnavailable')); return; }
          cartBusy = true; form.dataset.busy = 'true'; form.setAttribute('aria-busy', 'true');
          const submit = form.querySelector('[data-mv-add]'); if (submit) submit.disabled = true;
          const choices = Array.from(form.querySelectorAll('[data-mv-option]')); choices.forEach((input) => { input.dataset.wasDisabled = String(input.disabled); input.disabled = true; });
          if (panel && form.closest('[data-mv-quickshop]')) submit.textContent = t('adding');
          let confirmed = false;
          try {
            const sectionIds = Array.from(new Set(Array.from(document.querySelectorAll('cart-items-component')).map((item) => item.dataset.sectionId).filter(Boolean))).slice(0, 5);
            const payload = { items: [{ id: Number(variantId), quantity }] };
            if (sectionIds.length) { payload.sections = sectionIds; payload.sections_url = window.location.pathname; }
            const endpoint = form.getAttribute('action').replace(/\.js$/, '') + '.js';
            const response = await fetch(endpoint, { method: 'POST', credentials: 'same-origin', signal, headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
            const added = await response.json();
            if (!response.ok || added.status) { const message = typeof added.description === 'string' ? added.description : t('addError'); feedback(message); return; }
            confirmed = true;
            const cartResponse = await fetch(root.dataset.cartUrl.replace(/\.js$/, '') + '.js', { credentials: 'same-origin', signal, cache: 'no-store', headers: { Accept: 'application/json' } });
            if (!cartResponse.ok) throw new Error('Cart refresh failed');
            const cart = await cartResponse.json();
            if (!Number.isInteger(cart.item_count)) throw new Error('Cart count unavailable');
            eventModule ||= import('@shopify/events');
            const { CartLinesUpdateEvent } = await eventModule;
            if (panel && !panel.hidden) closePanel();
            const feedbackArea = card.querySelector('[data-mv-feedback]');
            if (feedbackArea) feedbackArea.hidden = true;
            announce(t('added'));
            card.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: variantId, quantity }], promise: Promise.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'mvurra-home-cards', sourceId: card.id, itemCount: quantity, productId: card.dataset.productId, sections: added.sections, didError: false } }) }));
          } catch {
            if (signal.aborted || !root.isConnected) return;
            if (confirmed) { announce(t('addedOpening')); window.location.assign(root.dataset.cartUrl); }
            else feedback(t('unconfirmed'));
          } finally {
            cartBusy = false; form.dataset.busy = 'false'; form.removeAttribute('aria-busy');
            choices.forEach((input) => { input.disabled = input.dataset.wasDisabled === 'true'; delete input.dataset.wasDisabled; });
            if (panel && form.closest('[data-mv-quickshop]')) refreshOptions(); else if (submit) submit.disabled = false;
          }
        }));
        const controls = card.querySelector('[data-mv-card-controls]'); if (controls) controls.hidden = false;
      });
      updateSaved(); if (toolbar) toolbar.hidden = false;
      on(window, 'storage', (event) => { if (durableStorage && (event.key === storageKey || event.key === null)) { saved = decodeSaved(event.newValue); updateSaved(); } });
    };
    import('@theme/component').then(({ Component }) => {
      if (customElements.get('mvurra-product-cards')) return;
      class MvurraProductCards extends Component {
        connectedCallback() { super.connectedCallback(); initialize(this); }
        updatedCallback() { super.updatedCallback(); this._mvCardController?.abort(); delete this.dataset.mvCardsInitialized; initialize(this); }
        disconnectedCallback() { super.disconnectedCallback(); this._mvCardController?.abort(); delete this.dataset.mvCardsInitialized; }
      }
      customElements.define('mvurra-product-cards', MvurraProductCards);
    }).catch(() => { /* Native product links remain available when enhancement cannot load. */ });
  })();


  } catch(e) { console.error(e); }
})();
})();
